import { ObjectCategories } from "../containers/centralView/administrationView/AdministrationPermissionExtendedView/types/administrationsPermissionExtendedViewProps";
import { ObjectState, ProcessMarker } from "../containers/centralView/taskListView/types/tasklListViewProps";
import { Roles } from "../contexts/authContext";
import { ExtendedUserPermissions } from "../contexts/permissionsContext";
import { ObjectType } from "../contexts/types/card";

const _canHaveEditorAssignedByAdmin = [ObjectState.Assigned, ObjectState.AnalysisSuccess, ObjectState.AnalysisDecision, ObjectState.WaitingRoomEdition, 
    ObjectState.DownloadedForEdition, ObjectState.Complete, ObjectState.ToBeCorrected];
const _canHaveEditorAssignedByVerifier = [ObjectState.WaitingRoomEditionVerification, ObjectState.DownloadedForVerification];
const _canHaveVerifierAssignedByAdmin = [ObjectState.ToBeVerified, ObjectState.WaitingRoomEditionVerification, ObjectState.DownloadedForVerification];
const _canHaveVerifierAssignedByEditor = [ObjectState.Complete];
const _canHaveVerifierAssignedByExtendedEditor = [ObjectState.Complete, ObjectState.WaitingRoomEdition, ObjectState.DownloadedForEdition];

export const canAssignEditor = (rolePermission: boolean, userRoles: string[], objectStatus: string, isWaitingRoom: boolean) => {
    if (!rolePermission) return false;

    var canAssign = false;

    if ((userRoles.includes(Roles.PwaAdmin) && canHaveEditorAssignedByAdmin(objectStatus as ObjectState)) ||
        (userRoles.includes(Roles.PwaVerificator) && canHaveEditorAssignedByVerifier(objectStatus as ObjectState, isWaitingRoom))) { 
            canAssign = true; 
    }

    return canAssign;      
}

export const canAssignVerifier = (rolePermission: boolean, extendedUserPermissions: ExtendedUserPermissions, userRoles: string[], objectType: string, 
    objectStatus: string, teryts: string, isWaitingRoom: boolean, processMarker: string) => {
    // Check role permission
    if (!rolePermission) return false;

    var canAssign = false;
    // Check object status permission
    if ((userRoles.includes(Roles.PwaAdmin) && canHaveVerifierAssignedByAdmin(objectStatus as ObjectState)) ||
        ((userRoles.includes(Roles.PwaEditor) || userRoles.includes(Roles.PwaEditorExtended) || checkIfNewRole(userRoles)) && canHaveVerifierAssignedByEditor(objectStatus as ObjectState)) ||
        (userRoles.includes(Roles.PwaEditorExtended) && canHaveVerifierAssignedByExtendedEditor(objectStatus as ObjectState, isWaitingRoom, processMarker === ProcessMarker.O))) { 
            canAssign = true; 
    }
    // Check extended user permissions
    if (canAssign) {
        if (extendedUserPermissions.userObjectCategories?.length! > 0) {
            if (objectType === ObjectType.KRO) canAssign = extendedUserPermissions.userObjectCategories?.includes(ObjectCategories.Landslide)!;
            if (objectType === ObjectType.KRTZ) canAssign = extendedUserPermissions.userObjectCategories?.includes(ObjectCategories.EndangeredArea)!;
        }
        if (canAssign && teryts && teryts !== null && (extendedUserPermissions.userGminy?.length! > 0 || extendedUserPermissions.userPowiaty?.length! > 0)) {
            var terytList = teryts.split(', ');
            canAssign = terytList.some(item => 
                extendedUserPermissions.userGminy?.includes(item) || extendedUserPermissions.userPowiaty?.includes(item.substring(0, 4)));
        }
    }
    return canAssign;      
}

export const checkIfNewRole = (userRoles: string[]) => {
    var baseRoles: string[] = [Roles.PwaAdmin, Roles.PwaDictAdmin, Roles.PwaVerificator, Roles.PwaEditorExtended, Roles.PwaEditor];
    return userRoles.some(role => !baseRoles.includes(role) && role.startsWith("PWA_"));
}

export const canAssignEditorInForm = (rolePermission: boolean, userRoles: string[], objectStatus: string) => {
    return rolePermission && userRoles.includes(Roles.PwaVerificator) && canHaveEditorAssignedByVerifier(objectStatus as ObjectState);      
}

export const canHaveEditorAssignedByAdmin = (state: ObjectState) => {
    return _canHaveEditorAssignedByAdmin.includes(state);
}

export const canHaveEditorAssignedByVerifier = (state: ObjectState, isWaitingRoom?: boolean) => {
    if (isWaitingRoom && state === ObjectState.DownloadedForVerification) return false;
    return _canHaveEditorAssignedByVerifier.includes(state);
}

export const canAssignVerifierInForm = (rolePermission: boolean, extendedUserPermissions: ExtendedUserPermissions, userRoles: string[], objectType: string, 
    objectStatus: string, teryts: string, processMarker: string) => {
    // Check role permission and object status permission
    var canAssign = rolePermission && userRoles.includes(Roles.PwaEditorExtended) && canHaveVerifierAssignedByExtendedEditor(objectStatus as ObjectState, false, processMarker === ProcessMarker.O);

    // Check extended user permissions
    if (canAssign) {
        if (extendedUserPermissions.userObjectCategories?.length! > 0) {
            if (objectType === ObjectType.KRO) canAssign = extendedUserPermissions.userObjectCategories?.includes(ObjectCategories.Landslide)!;
            if (objectType === ObjectType.KRTZ) canAssign = extendedUserPermissions.userObjectCategories?.includes(ObjectCategories.EndangeredArea)!;
        }
        if (canAssign && teryts && teryts !== null && (extendedUserPermissions.userGminy?.length! > 0 || extendedUserPermissions.userPowiaty?.length! > 0)) {
            var terytList = teryts.split(', ');
            canAssign = terytList.some(item => 
                extendedUserPermissions.userGminy?.includes(item) || extendedUserPermissions.userPowiaty?.includes(item.substring(0, 4)));
        }
    }
    return canAssign;      
}

export const canHaveVerifierAssignedByAdmin = (state: ObjectState) => {
    return _canHaveVerifierAssignedByAdmin.includes(state);
}

export const canHaveVerifierAssignedByEditor = (state: ObjectState) => {
    return _canHaveVerifierAssignedByEditor.includes(state);
}

export const canHaveVerifierAssignedByExtendedEditor = (state: ObjectState, isWaitingRoom: boolean, isProcessMarkerO: boolean) => {
    if (isWaitingRoom && state === ObjectState.DownloadedForEdition) return false;
    if (isProcessMarkerO) return _canHaveVerifierAssignedByExtendedEditor.includes(state);
    else return state === ObjectState.Complete;
}

export const getObjectTypeCodedValue = (objectType: ObjectType) => {
    switch (objectType){
        case ObjectType.POO || ObjectType.POTZ: return "po"
        case ObjectType.KRO: return "osuwisko"
        case ObjectType.KRTZ: return "tz"
    }
}